import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useCarExpenseSearchMutation } from '../../../services'
import ExpenseTypeTable from './components/ExpenseTypeTable'
import { UspConfigurationCarExpenseTypeView } from '../../../models'
import Header from '../components/Header/Header'
import AddEditExpenseTypesModal from './components/AddEditExpenseTypesModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsExpenses = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCarExepnse, { data, isLoading }] = useCarExpenseSearchMutation()
  const [carExpenseData, setCarExpenseData] = useState<UspConfigurationCarExpenseTypeView[]>([])

  const handleSubmit = (values?: any) => {
    searchCarExepnse({
      carExpenseTypeSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarExpenseData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Expense Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Expense Types' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <ExpenseTypeTable
                      loading={isLoading}
                      data={carExpenseData}
                      setData={setCarExpenseData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditExpenseTypesModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarExpenseTypeView}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsExpenses
